/**
 * The Loading component, used while resources load
 * Keep this component as similar as possible to the resource page importing it
 */
import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col, Card, CardTitle, CardBody } from "reactstrap";

import {
  FILEEDITOR,
  FILEEDITORTYPENAMES,
} from "../../FileUploadEditorForm/utils/fileEditor";
import checkMarkSVG from "../../../assets/images/icons/checkmark.svg";
import { useFormContext, useWatch } from "react-hook-form";

const MaterialTab = ({ editorTypeId }, context) => {
  const editorData = FILEEDITOR[editorTypeId];
  const { register, control, setValue } = useFormContext();
  const selectedLaminate = useWatch({
    control,
    name: "laminate",
  });

  // Please keep this so we can translate it...
  const translationExtractHelper = () => {
    return (
      <>
        <>
          {context.t("materials.STICKER.title")}{" "}
          {context.t("materials.STICKER.description")}
        </>
        <>
          {context.t("materials.CUTTINGPLOTT.title")}{" "}
          {context.t("materials.CUTTINGPLOTT.description")}
        </>
        <>
          {context.t("materials.PERFORATED.title")}{" "}
          {context.t("materials.PERFORATED.description")}
        </>
        <>
          {context.t("materials.FLOORPRINT.title")}{" "}
          {context.t("materials.FLOORPRINT.description")}
        </>
        <>
          {context.t("materials.ADHESION.title")}{" "}
          {context.t("materials.ADHESION.description")}
        </>
        <>
          {context.t("materials.TEXTEDITOR.title")}{" "}
          {context.t("materials.TEXTEDITOR.description")}
        </>
        <>
          {context.t("materials.MAGNETIC.title")}{" "}
          {context.t("materials.MAGNETIC.description")}
        </>
        <>
          {context.t("materials.PHOTOWALLPAPER.title")}{" "}
          {context.t("materials.PHOTOWALLPAPER.description")}
        </>
        <>
          {context.t("materials.CANVAS.title")}{" "}
          {context.t("materials.CANVAS.description")}
        </>
        <>
          {context.t("materials.FROSTED.title")}{" "}
          {context.t("materials.FROSTED.description")}
        </>
        <>
          {context.t("materials.ALUSIGN.title")}{" "}
          {context.t("materials.ALUSIGN.description")}
        </>
        <>
          {context.t("materials.SEALLABEL.title")}{" "}
          {context.t("materials.SEALLABEL.description")}
        </>
        <>
          {context.t("materials.POSTER.title")}{" "}
          {context.t("materials.POSTER.description")}
        </>
        <>
          {context.t("materials.PVCSIGN.title")}{" "}
          {context.t("materials.PVCSIGN.description")}
        </>
        <>
          {context.t("materials.BANNERPVC.title")}{" "}
          {context.t("materials.BANNERPVC.description")}
        </>
        <>
          {context.t("materials.BANNERMESH.title")}{" "}
          {context.t("materials.BANNERMESH.description")}
        </>
        <>
          {context.t("materials.ROLLUP.title")}{" "}
          {context.t("materials.ROLLUP.description")}
        </>
        <>
          {context.t("materials.STICKER_RECTANGULAR.title")}{" "}
          {context.t("materials.STICKER_RECTANGULAR.description")}
        </>
        <>
          {context.t("materials.STICKER_CUT.title")}{" "}
          {context.t("materials.STICKER_CUT.description")}
        </>
        <>
          {context.t("materials.STICKER_CIRCLE.title")}{" "}
          {context.t("materials.STICKER_CIRCLE.description")}
        </>
        <>
          {context.t("materials.STICKER_PREMIUM.title")}{" "}
          {context.t("materials.STICKER_PREMIUM.description")}
        </>
        <>
          {context.t("materials.BLANK_FILM_CUT.title")}{" "}
          {context.t("materials.BLANK_FILM_CUT.description")}
        </>
        <>
          {context.t("materials.STICKER_DOTTED.title")}{" "}
          {context.t("materials.STICKER_DOTTED.description")}
        </>
        <>
          {context.t("materials.STICKER_STRONG.title")}{" "}
          {context.t("materials.STICKER_STRONG.description")}
        </>
        <>
          {context.t("materials.STICKER_CARAVAN.title")}{" "}
          {context.t("materials.STICKER_CARAVAN.description")}
        </>
        <>
          {context.t("materials.STICKER_PVC_FREE.title")}{" "}
          {context.t("materials.STICKER_PVC_FREE.description")}
        </>
        <>
          {context.t("materials.FLOORPRINT_ECO.title")}{" "}
          {context.t("materials.FLOORPRINT_ECO.description")}
        </>
        <>
          {context.t("materials.STICKER_WHITEPRINT.title")}{" "}
          {context.t("materials.STICKER_WHITEPRINT.description")}
        </>
        <>
          {context.t("laminates.glossy.title")}{" "}
          {context.t("laminates.matt.title")}{" "}
          {context.t("laminates.none.title")}{" "}
        </>
      </>
    );
  };
  if (translationExtractHelper) {
    // We keep this to avoid a linter warning
  }

  return (
    <Container>
      <div className="h4">{context.t("material")}</div>
      <Row>
        {editorData?.laminates.map((availableLaminate) => (
          <Col xs={12} md={4} key={availableLaminate.key}>
            <Card
              onClick={() => setValue("laminate", availableLaminate.key)}
              className={`hv-pointer mb-2 ${
                selectedLaminate === availableLaminate.key
                  ? "border-success"
                  : ""
              }`}
            >
              <CardBody className="p-3">
                <Row>
                  <Col xs={{ size: 9, order: 2 }} md={{ size: 12 }}>
                    <span className="">
                      <input
                        {...register("laminate", { required: true })}
                        type="radio"
                        name="laminate"
                        value={availableLaminate.key}
                        style={{ display: "none" }}
                        id={availableLaminate.key}
                      />
                      {context.t(
                        "materials." +
                          FILEEDITORTYPENAMES[editorTypeId] +
                          ".title"
                      )}
                      ,{" "}
                      {context.t(
                        "laminates." + availableLaminate.key + ".title"
                      )}
                    </span>
                  </Col>

                  <Col
                    xs={{ size: 3, order: 1 }}
                    md={{ size: 12 }}
                    className={
                      "laminate-field--icon-container col-3 " +
                      (selectedLaminate === availableLaminate.key
                        ? " selected"
                        : "")
                    }
                  >
                    <img
                      src={availableLaminate.iconURL}
                      alt={availableLaminate.key}
                      className={`laminate-field--icon laminate-ad-hoc--${availableLaminate.key}`}
                      loading="lazy"
                      style={{ maxWidth: "100%" }}
                    />
                  </Col>
                  {selectedLaminate === availableLaminate.key && (
                    <img
                      src={checkMarkSVG}
                      alt={"selected_option"}
                      className="laminate-field--checkmark"
                      loading="lazy"
                      style={{
                        position: "absolute",
                        right: "0.5rem",
                        top: "0.75rem",
                      }}
                    />
                  )}
                </Row>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
      <p className="h5 mt-3">
        {context.t("materials." + FILEEDITORTYPENAMES[editorTypeId] + ".title")}
      </p>
      <p>
        {context.t(
          "materials." + FILEEDITORTYPENAMES[editorTypeId] + ".description"
        )}
      </p>
    </Container>
  );
};
/**  define proptype for the 'translation' function  */
MaterialTab.contextTypes = {
  t: PropTypes.func,
};
export default MaterialTab;
